import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import EventList from './pages/EventList';
import EventDetail from './pages/EventDetail';
import NewEvent from './pages/NewEvent';
import EditEvent from './pages/EditEvent';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Home from './pages/Home';
import { useAuth } from './contexts/AuthContext';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import WishList from './pages/WishList';
import MomentList from './pages/MomentList';
import NewMoment from './pages/NewMoment';
import MomentDetail from './pages/MomentDetail';
import Friends from './pages/Friends';
import FriendProfile from './pages/FriendProfile';
import FriendWishes from './pages/FriendWishes';
import FriendMoments from './pages/FriendMoments';
import './App.css';

function AppContent() {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="app">
      <header className="app-header">
        <Link to="/" className="app-header-title">
          <h1>Event Manager</h1>
        </Link>
        <nav className="app-header-nav">
          <Link to="/events" className="header-link">Events</Link>
          {isAuthenticated ? (
            <>
              <Link to="/wishes" className="header-link">My Wishes</Link>
              <Link to="/moments" className="header-link">My Moments</Link>
              <Link to="/friends" className="header-link">Friends</Link>
              <button onClick={handleLogout} className="header-link header-btn">Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/signin" className="header-link">Sign In</Link>
              <Link to="/signup" className="header-link">Sign Up</Link>
            </>
          )}
        </nav>
      </header>
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<EventList />} />
          <Route path="/events/new" element={<NewEvent />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/events/:id/edit" element={<EditEvent />} />
          <Route path="/events/:id/moments/new" element={<NewMoment />} />
          <Route path="/wishes" element={<WishList />} />
          <Route path="/moments" element={<MomentList />} />
          <Route path="/moments/:id" element={<MomentDetail />} />
          <Route path="/friends" element={<Friends />} />
          <Route path="/friends/:id" element={<FriendProfile />} />
          <Route path="/friends/:id/wishes" element={<FriendWishes />} />
          <Route path="/friends/:id/moments" element={<FriendMoments />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
